<template>
  <vue-modal
    id="newReservationModal"
    classes="vue-modal-container tabos"
    height="auto"
    name="new-reservation-modal"
    width="360px"
    @before-open="beforeModalOpen"

  >
    <div :set="(clubInfo = pfClientActive ? partnersAt(startTime) : {})"
         class='info-header'>
      <!--{{ trans.subject }}: -->{{ subjectTypeName }} {{ subjectName }}<br/>
      <!--{{ trans.date }}: -->{{ startTime }}
      <button
        class="close-modal"
        @click="$modal.hide('new-reservation-modal')"
      >
        <i class="close icon"/></button>
      <!-- {{timeBlock}}           -->
      <!--{{clubInfo}}-->
    </div>

    <div class="ui top attached tabular menu">
      <div :class="{active:activeTab=='reserve'}"
           class="item"
           @click="activeTab='reserve'">{{ trans.header }}
      </div>
      <div v-if="pfClientActive && !$store.getters.isDigitalMode"
           :class="{active:activeTab=='club'}"
           class="item"
           @click="activeTab='club'">Club
      </div>
    </div>

    <div :class="{active:activeTab=='reserve'}"
         class='ui bottom attached tab segment'>

      <div class="content">
        <div v-if="paymentConfig && ticketPrice">
          <div>{{ trans.payable }}</div>
          <div>{{ trans.ticketPrice }}: {{ ticketPrice }}</div>
          <div v-if="Number(balanceInCurrentClient) !== 0">
            {{ trans.balance }}: {{ balanceInCurrentClient }} Ft
          </div>
          <div
            v-if="
              balanceInCurrentClient < 0 &&
              !paymentConfig.isRequiredToPayTheNegativeBalance
            "
            class="ui checkbox"
          >
            <input
              v-model="wantToPayNegativeBalance"
              name="negativeBalance"
              type="checkbox"
            />
            <label>{{ trans.negativeBalancePay }}</label>
          </div>
          <div v-if="Number(balanceInCurrentClient) !== 0">
            {{ trans.annualPayable }}:
            {{ getPaymentAmount(ticketPrice, balanceInCurrentClient) }} Ft
          </div>
        </div>
        <div v-else>
          <!--NOOOO<br/>
          {{paymentConfig}}<br/>
          {{ticketPrice}}<br/>-->
        </div>
        <div
          v-if="clientConfig && clientConfig.enableTimetableExtraOptions"
          class="extra-options-container"
        >
          <h5 class="subheader">{{ trans.extraOptionsSubHeader }}</h5>
          <timetable-extra-options
            :id="`timetableExtraOptions_${_uid}`"
            :extra-options="timetableExtraOptions"
          />
        </div>
      </div>
      <div v-if="paymentConfig && !paymentConfig.isOptional"
           class="actions">
        <!-- Need to pay -->
        <div class="ui positive approve button"
             @click="reserve">
          {{ trans.payAndReserveBtnText }}
        </div>
        <div
          class="ui cancel button"
          @click="$modal.hide('new-reservation-modal')"
        >
          {{ trans.cancel }}
        </div>
      </div>
      <div
        v-else-if="paymentConfig && paymentConfig.isOptional"
        class="actions"
      >
        <!-- Can choose pay or not -->
        <div
          v-if="!$store.getters.isDigitalMode"
          class="fluid ui positive basic button"
          style="margin-bottom: 5px"
          @click="$modal.show('pass-buy-modal', {client: $store.state.currentClientDomain})"
        >
          {{ trans.passBuyBtnTxt }}
        </div>
        <div
          class="fluid ui positive approve button"
          style="margin-bottom: 5px"
          @click="reserve(true)"
        >
          {{ trans.payAndReserveBtnText2 }}
        </div>
        <div
          v-if="!$store.getters.isDigitalMode"
          class="ui positive approve button small-action-btn"
          @click="reserve(false)"
        >
          {{ trans.reserveBtnText }}
        </div>
        <div
          class="ui cancel button small-action-btn"
          @click="$modal.hide('new-reservation-modal')"
        >
          {{ trans.cancelModal }}
        </div>
      </div>
      <div v-else
           class="actions">
        <div
          class="ui positive approve button small-action-btn"
          @click="reserve"
        >
          {{ trans.reserveBtnText2 }}
        </div>
        <!--<div
          class="ui positive approve button small-action-btn"
          @click="reserve(false, true)"
        >
          Foglalás partnerrel
        </div>-->
        <div
          class="ui cancel button small-action-btn"
          @click="$modal.hide('new-reservation-modal')"
        >
          {{ trans.cancelModal2 }}
        </div>
      </div>
    </div> <!-- /tab -->
    <div :class="{active:activeTab=='club'}"
         class='ui bottom attached tab segment'>
      <partner-finder-extra
        v-if="pfClientActive"
        :clubInfo="clubInfo"
        :from_time="startTime"
        :reserveExtra="reserveExtra"
        :subject_id="subjectId"
      />
    </div>
  </vue-modal>
</template>

<script>
import TimetableExtraOptions from '@/components/components/TimetableExtraOptions';
import PartnerFinderExtra from '@/components/partnerFinder/PartnerFinderExtra';
import {mapGetters, mapState} from 'vuex';
import {pfGetClientActive, pfGetPartnersAt} from '../../store/partnerFinder';


export default {
  props: [
    'timeBlock',
    'startTime',
    'subjectId',
    'subjectName',
    'subjectTypeName',
    'ticketPrice',
  ],
  data () {
    return {
      activeTab: 'reserve',
      wantToPayNegativeBalance: true,
      reserveExtra: {},
    };
  },
  methods: {
    reserve (wantToPay = false, withPartner = false) {
      console.log('RESERVE_EXTRA', this.reserveExtra);
      let reservationData = {
        subjectID: this.subjectId,
        start: this.startTime,
        wantToPay: wantToPay,
        withPartner,
        ...this.reserveExtra,
      };
      // Extra options
      if (this.clientConfig && this.clientConfig.enableTimetableExtraOptions) {
        const extraOptionInputs = document
          .getElementById(`timetableExtraOptions_${this._uid}`)
          .getElementsByTagName('input');
        const selectedExtraOptionIDs = [];
        for (let extraOptionInput of extraOptionInputs) {
          if (extraOptionInput.checked)
            selectedExtraOptionIDs.push(extraOptionInput.dataset.optionId);
        }
        reservationData.timetableExtraOptions = selectedExtraOptionIDs;
      }
      // ./ Extra options

      if (
        this.paymentConfig &&
        !this.paymentConfig?.isRequiredToPayTheNegativeBalance
      ) {
        reservationData.wantToPayNegativeBalance =
          this.wantToPayNegativeBalance;
      }
      this.$parent.$emit('create-new-reservation', reservationData);
      this.$modal.hide('new-reservation-modal');
    },
    getPaymentAmount (ticketPrice, balanceInCurrentClient) {
      let amount =
        Number(ticketPrice.slice(0, ticketPrice.indexOf(' '))) -
        Number(balanceInCurrentClient);
      return amount < 0 ? 0 : amount;
    },

    beforeModalOpen (/*event*/) {
      //if (!this.pfClientActive && this.activeTab == 'club')
      this.activeTab = 'reserve';
      console.log('TIMEBLOCK:', this.timeBlock);

    },
  }, // methods
  computed: {
    ...mapState({
      trans: (state) => state.trans.newReservationModal,
    }),
    ...mapGetters({
      pfClientActive: pfGetClientActive,
      partnersAt: pfGetPartnersAt,
    }),
    clientConfig () {
      return this.$store.getters.getClientConfig(
        this.$store.state.currentClientDomain,
      );
    },
    paymentConfig () {
      const clients = this.$store.state.clients;
      const currentClientDomain = this.$store.state.currentClientDomain;

      /*console.log("---------------------- paymentConfig ----------------------")
      console.log('currentClientDomain='+currentClientDomain);
      console.log('ownerDomain='+this.$store.state.ownerDomain);*/
      for (let client of clients) {
        //console.log('>' + client?.domain);
        if (
          client?.domain === currentClientDomain
          //|| client?.domain === this.$store.state.ownerDomain
        ) {
          //console.log('>>found', client);
          return client.config?.payment;
        }
      }
      //console.log('>>not found');
      return false;
    },
    balanceInCurrentClient () {
      const currentClientDomain = this.$store.state.currentClientDomain;
      const balances = this.$store.state.balances;
      for (let balance of balances) {
        if (
          balance.client === currentClientDomain //||  balance.client === this.$store.state.ownerDomain
        ) {
          return balance?.amount;
        }
      }
      return false;
    },
    timetableExtraOptions () {
      return this.$store.getters.getClientTimetableExtraOptionsBySubjectType(
        this.$store.state.currentClientDomain,
        this.subjectTypeName,
      );
    },
  }, // computed
  components: {
    TimetableExtraOptions,
    PartnerFinderExtra,
  },
};
</script>

<style scoped>
.info-header {
  padding-top: 1em;
  text-align: left;
  padding-left: 1em;
  color: #d65306;
  text-shadow: 1px 1px #eaeaea;
}


.small-action-btn {
  width: 48%;
}

.subheader {
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  padding: 0.5rem;
}

.extra-options-container {
  margin-top: 1rem;
}

.pf-outer > .button {
  margin-bottom: 5px;
}
</style>
